export default __webpack_public_path__ + "static/media/1.40858397.png";